import React from "react";
import dynamic from "next/dynamic";

const ImageUI = dynamic(() => import("@/common/UI/Image"));
const Link = dynamic(() => import("@/common/UI/Link"));

const Logo = (props) => {
  const { width, height, imageSrc, imageAlt, imageTitle } = props;
  return (
    <>
      {imageSrc ? (
        <Link href="/">
          <ImageUI
            src={imageSrc}
            alt={imageAlt}
            title={imageTitle}
            width={width ? width : 206}
            height={height ? height : 85}
          />
        </Link>
      ) : null}
    </>
  );
};

export default Logo;
